module.exports = __webpack_public_path__ + "5b86af3fe6bb300ea5ecaea14f2a9833.svg";